import {Modal} from "theme";

function debounce(fun, time) {
    let timer
    return function () {
        clearTimeout(timer)
        let args = arguments
        timer = setTimeout(() => {
            fun.apply(this, args)
        }, time)
    }
}

const ast = {
    delayTime: 200

}

class ResizeObserverWrapper {
    _lastWidth
    _lastHeight

    observe(htmlElement, onSizeChanged) {
        new ResizeObserver(debounce(function (entries) {
            if (entries != undefined && entries.length > 0) {
                const newWidth = entries[0].target.clientWidth
                const newHeight = entries[0].target.clientHeight

                if (newWidth != undefined && newWidth > 0 && newHeight != undefined && newHeight > 0) {
                    let dimensionChanged = (newWidth != this._lastWidth && this._lastWidth > 0) || (newHeight != this._lastHeight && this._lastHeight > 0)
                    this._lastHeight = newHeight
                    this._lastWidth = newWidth
                    if (dimensionChanged) {
                        onSizeChanged()
                    }
                }
            }
        }, ast.delayTime)).observe(htmlElement)
    }
}

/**
 *  ast-com-carousels
 */
class AstComCarousels extends HTMLElement {

    //
    // static get observedAttributes() {
    //     return ['slidesPerView'];
    // }
    //
    // attributeChangedCallback(attrName, oldVal, newVal) {
    //     if (oldVal !== newVal) {
    //         console.log('newVal',newVal)
    //     }
    // }

    constructor() {
        super()
        this.options = {
            id: this.getAttribute("swiper-id"),
            perViewDesktop: this.getAttribute("per-view-desktop") * 1,
            perViewLargeLaptop: this.getAttribute("per-view-large-laptop") * 1,
            perViewLaptop: this.getAttribute("per-view-laptop") * 1,
            perViewTablet: this.getAttribute("per-view-tablet") * 1,
            perViewMobile: this.getAttribute("per-view-mobile") * 1,
            enableNavigationButton: this.getAttribute("enable-navigation-button") === 'true'
        }
        this._init()
    }

    _init() {
        var base = this


        window.$(function () {
            // var options = JSON.parse(base.children[0].textContent)
            var options = base.options
            var id = '#' + options.id
            new Swiper(id, {
                slidesPerView: options.perViewMobile,
                //spaceBetween: 20,
                lazyPreloadPrevNext: 1,
                lazyPreloaderClass: 'ast-com-carousels-lazy-preloader',

                breakpoints: {
                    768: {
                        slidesPerView: options.perViewTablet,
                    },
                    1024: {
                        slidesPerView: options.perViewLaptop,
                    },
                    1440: {
                        slidesPerView: options.perViewLargeLaptop,
                    },
                    1441: {
                        slidesPerView: options.perViewDesktop,
                    }
                },

                navigation: {
                    enabled: options.enableNavigationButton,
                    nextEl: id + " .js-swiper-button-next",
                    prevEl: id + " .js-swiper-button-prev",
                },

            });

        })
    }
}

if (!customElements.get('ast-com-carousels')) {
    customElements.define('ast-com-carousels', AstComCarousels)
}

/**
 *  ast-com-tab-navigation
 */
class AstComTabNavigation extends HTMLElement {
    constructor() {
        super()


        this._init()
    }

    _init() {
        // scroll bar initialization
        // this._initScrollTop()
        // component initialization
        this._onLoad()

    }


    /*
     * ============================================   on listener  ==========================================
     */

    _onResize() {
        const t = this
        new ResizeObserverWrapper().observe(document.documentElement, function () {

            t._initSidebarAndAnchor()
            t._onScrolling()
            //  t._initJumpToAnchor()
        })

    }

    _onLoad() {
        window.addEventListener('load', () => {
            // Create elements and data
            this.el = this._initEl()
            if (this.el.navigationLinks.length) {
                // Initialize css variables
                //this._initStyleVariable()
                this._onScrolling()
                // scrolling listener
                this._onScroll()
                // window change listener
                this._onResize()
            }


            // Initialization automatically jumps to the anchor point
            //   this._initJumpToAnchor()

        })
    }

    /**
     * Listen for scroll bars
     * @private
     */
    _onScroll() {
        window.addEventListener('scroll', // anti shake
            debounce(() => {
                this._onScrolling()
            }, ast.delayTime), {
                passive: true
            })
    }

    /**
     * The scroll bar is scrolling
     * @private
     */
    _onScrolling() {
        let rootTop = Math.abs(this.el.root.getBoundingClientRect().top - 1)
        let activeId = ''
        const mArticleAnchors = this.el.mArticleAnchors
        const mSidebarLinks = this.el.mSidebarLinks

        //
        Array.from(mArticleAnchors).some(([id, {top, bottom}], index) => {
            const isActiveId = this._numberInRange(rootTop, top, bottom)
            if (isActiveId) {
                activeId = id
                return true
            }
        })
        //
        // First determine whether it exceeds the first one
        // if (!activeId.length) {
        //     const firstLink = mArticleAnchors.get(this.el.firstId)
        //     if (rootTop <= firstLink.top) {
        //         activeId = this.el.firstId
        //     }
        // }

        // Whether it exceeds the last one
        if (!activeId.length) {
            const firstLink = mArticleAnchors.get(this.el.firstId)
            if (rootTop <= firstLink.top) {
                this._removeStyleVariable()
                this.el.wrapper.classList.remove('collapsed')
            }

            const lastLink = mArticleAnchors.get(this.el.lastId)
            if (rootTop >= lastLink.bottom) {
                //  activeId = this.el.lastId
                this.el.wrapper.classList.add('collapsed')
            }

        }


        // activeId exist
        if (activeId.length) {
            if (this.el.wrapper.classList.contains('collapsed')) {
                this.el.wrapper.classList.remove('collapsed')
            }

            this.activeId = activeId
            const activeLink = mSidebarLinks.get(activeId)
            this._updateStyleVariable(activeLink)
        }
    }

    /*
     * ============================================    init function   ==========================================
     */

    /**
     * Window changes recalculate position
     * @private
     */
    _initSidebarAndAnchor() {
        const headerHeight = this.el.headerHeight
        const thisHeight = this.el.thisHeight

        this.el.mSidebarLinks.forEach(({link}, key, map) => {
            map.set(key, {
                trackerLeft: link.offsetLeft, width: link.scrollWidth, link
            })
        })
        const rootTop = this.el.root.getBoundingClientRect().top

        this.el.mArticleAnchors.forEach(({anchor}, key, map) => {
            const {top, bottom} = anchor.getBoundingClientRect()

            //- headerHeight - thisHeight
            const anchorTop = Math.floor(top - rootTop - headerHeight - thisHeight)
            const anchorBottom = Math.floor(bottom - rootTop - headerHeight - thisHeight)
            map.set(key, {
                top: anchorTop, bottom: anchorBottom, anchor
            })
        })

    }

    _initEl() {
        const root = document.documentElement
        // navigation
        const sidebar = this.querySelector('.js-tab-list')
        const wrapper = this.querySelector('.js-tab-wrapper')

        const thisHeight = sidebar.getBoundingClientRect().height
        root.style.setProperty('--ast-com-tab-navigation-height', `${thisHeight}px`);


        // head height
        const headerHeight = this._getHeaderHeight(root)
        // navigation links
        let navigationLinks = this.querySelectorAll('a')
        navigationLinks = Array.from(navigationLinks)

        // Quickly obtain the map of data
        const mSidebarLinks = new Map()
        const mArticleAnchors = new Map()
        let firstId = ''
        let lastId = ''
        let linksLength = navigationLinks.length
        //
        const rootTop = root.getBoundingClientRect().top

        navigationLinks = navigationLinks.filter((link) => {
            const id = link.hash.replace(/#/g, '')
            const anchor = document.getElementById(id)
            if (!anchor) {
                link.parentElement.remove()
                return false
            }
            return true
        })

        if (navigationLinks.length) {
            // Loop set data
            navigationLinks.forEach((link, index) => {
                const id = link.hash.replace(/#/g, '')

                if (index === 0) {
                    firstId = id
                }
                if (index === linksLength - 1) {
                    lastId = id
                }
                //
                const anchor = document.getElementById(id)
                link.style.opacity = 1

                //  anchor top bottom
                const {top, bottom} = anchor.getBoundingClientRect()
                //- headerHeight - thisHeight
                const anchorTop = Math.floor(top - rootTop - headerHeight - thisHeight)
                const anchorBottom = Math.floor(bottom - rootTop - headerHeight - thisHeight)
                //
                mSidebarLinks.set(id, {
                    trackerLeft: link.offsetLeft, width: link.scrollWidth, link
                })
                //
                mArticleAnchors.set(id, {
                    top: anchorTop, bottom: anchorBottom, anchor
                })
            })
        } else {
            sidebar.style.display = 'none'
        }
        //
        return {
            root,
            sidebar,
            wrapper,
            navigationLinks,
            mSidebarLinks,
            mArticleAnchors,
            firstId,
            lastId,
            headerHeight,
            thisHeight
        }
    }

    /**
     * Initialize css variables
     * @private
     */
    _initStyleVariable() {

        //    const id = this._getHash() || this.el.firstId
        const id = this.el.firstId
        if (id) {
            const link = this.el.mSidebarLinks.get(id)
            this._updateStyleVariable(link)
        }

    }

    /**
     * Initialize scroll position
     * @private
     */
    _initScrollTop() {
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'
        } else {
            window.onbeforeunload = function () {
                window.scrollTo(0, 0)
            }
        }
    }

    /**
     * If the current browser has a hash, it will jump.
     * @private
     */
    _initJumpToAnchor() {
        const id = this._getHash()
        if (id) {
            const currentLink = this.el.mSidebarLinks.get(id)
            currentLink.link.click()
            this._updateStyleVariable(currentLink)
        }
    }

    /*
     * ============================================    utils  ==========================================
     */
    /**
     * Determine whether the value is within the range of two values
     * @param num
     * @param low
     * @param high
     * @returns {boolean}
     * @private
     */
    _numberInRange(num, low, high) {
        return num >= low && num <= high
    }


    /**
     * get hash
     * @returns {string}
     * @private
     */
    _getHash() {
        return location.hash.replace(/#/g, '')
    }


    /**
     * Get head height
     * @private
     */
    _getHeaderHeight(root) {
        // header
        let headerHeight = getComputedStyle(root).getPropertyValue('--header-height')
        return headerHeight && headerHeight.length ? parseFloat(headerHeight) : 0
    }

    /**
     * Modify css variables
     * @param link
     * @private
     */
    _updateStyleVariable(link) {
        const sidebar = this.el.sidebar
        //  sidebar.style.setProperty('--ast-com-tab-navigation-tracker-width', '10px')
        sidebar.style.setProperty('--ast-com-tab-navigation-tracker-scale-x', `${link.width / 10}`)
        sidebar.style.setProperty('--ast-com-tab-navigation-tracker-left', `${link.trackerLeft + link.width / 2 - 5}px`)
        //history.replaceState(history.state, "", `${location.pathname}${link.link.hash}`);

    }

    /**
     * Remove css variables
     * @private
     */
    _removeStyleVariable() {
        const sidebar = this.el.sidebar
        sidebar.style.removeProperty('--ast-com-tab-navigation-tracker-scale-x')
        sidebar.style.removeProperty('--ast-com-tab-navigation-tracker-left')

    }


}

if (!customElements.get('ast-com-tab-navigation')) {
    customElements.define('ast-com-tab-navigation', AstComTabNavigation)
}


/**
 *  ast-modal
 */
class AstComTabModal extends Modal {
    get shouldLock() {
        return false;
    }
}

if (!customElements.get('ast-com-tab-modal')) {
    customElements.define('ast-com-tab-modal', AstComTabModal)
}
